export default __webpack_public_path__ + "static/media/home-light.06b9ea4a.svg";